<template>
  <div class="my-order">
    <div class="page-title">{{ $t("message.home.myOrder") }}</div>
    <div class="tabs">
      <div v-for="tab in tabs" :key="tab.value" class="tab-item" :class="{ active: tabActive === tab.value }"
        @click="tabChange(tab.value, tab.status)">
        {{ tab.label }}
      </div>
    </div>
    <div style="width: 872px" v-loading="loading">
      <span v-if="objsList.length">
        <order-item
          v-for="item in objsList"
          :key="item.id"
          :data="item"
          :refresh="tapOrderStatus"
          @show-logistics="openLogistics"
        />
      </span>
      <el-empty v-if="!objsList.length && !loading" :description="$t('message.home.noData')"></el-empty>
    </div>
    <div v-if="objsList.length || total" class="common-pagination">
      <el-pagination background layout="total,prev,pager,next" class="es-pagination" :page-size="queryParams.pageSize"
        :pager-count="5" :current-page="queryParams.pageNumber" :total="total"
        @current-change="currentChange" />
    </div>

    <!-- 物流轨迹弹窗：仅用 view + transit_step，不依赖废弃组件 -->
    <el-dialog
      :visible.sync="logisticsDialogVisible"
      width="560px"
      :title="$t('message.home.order.logistics')"
      custom-class="logistics-dialog"
      :close-on-click-modal="true"
    >
      <div class="logistics-content" v-loading="logisticsLoading">
        <div v-if="logisticsCurrentShipping" class="logistics-header">
          <div class="logistics-express">
            <span class="label">{{ $t('message.home.order.expressCompany') || '快递公司' }}：</span>
            <span class="value">{{ logisticsCurrentShipping.expressCompany || '--' }}</span>
          </div>
          <div class="logistics-tracking">
            <span class="label">{{ $t('message.home.order.trackingNo') || '运单号' }}：</span>
            <span class="value">{{ logisticsCurrentShipping.trackingNo || '--' }}</span>
          </div>
        </div>

        <div class="logistics-timeline-wrap" v-if="logisticsSteps.length">
          <el-timeline>
            <el-timeline-item
              v-for="(step, i) in logisticsSteps"
              :key="i"
              :timestamp="formatLogisticsTime(step)"
              placement="top"
            >
              <div class="step-desc">{{ formatLogisticsText(step) }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>

        <div v-else-if="!logisticsLoading" class="logistics-empty">
          <p>{{ logisticsEmptyText }}</p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="logisticsDialogVisible = false">
          {{ $t('message.home.close') || '关闭' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OrderItem from "./components/order-item";

//////////////////////////////////////////////////////////////////////////////////////////////////

import {
  list,
  receive,
  cancel,
  view,
  transitStep,
} from "@/api/order/order.js"

//////////////////////////////////////////////////////////////////////////////////////////////////
export default {
  name: "my-order",
  components: { OrderItem },
  data() {
    return {
      tabs: [
        {
          label: this.$t("message.home.all"),
          value: "",
        },
        {
          label: this.$t("message.home.pending"), // 待支付
          value: 0,
          status: "PENDING_PAYMENT",
        },
        // {
        //   label: this.$t("message.home.cancelled"), // 以取消
        //   value: '-1',
        //   status:"",
        // },
        {
          label: this.$t("message.home.delivered"), // 待发货
          value: 1,
          status: "PENDING_SHIPMENT",
        },
        // {
        //   label: this.$t("message.home.confirmed"), // 已确认
        //   value: '2',
        // status:"",
        // },
        {
          label: this.$t("message.home.receipt"), // 待收货
          value: 3,
          status: "SHIPPED",
        },
        // {
        //   label: this.$t("message.home.harvested"), // 已收货
        //   value: 4,
        // status:"",
        // },
        // {
        //   label: this.$t("message.home.comment"), // 已评价
        //   value: 4,
        //   status:"",
        // },
        // {
        //   label: this.$t("message.home.refund"), // 已退款
        //   value: 6,
        //   status:"",
        // },
      ],
      tabActive: "",
      loading: false,
      // pageNum: 1,
      // pageSize: 5,
      // total: 0,

      //////////////////////////////////////////////////////////////////////////////////////////////////

      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 5,
      total: 0,
      totalPages: 0,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      hiddenmodalput: true,
      returnContentMsg: "",
      returnOrderId: "",
      //可以通过hidden是否掩藏弹出框的属性，来指定那个弹出框
      winWidth: 0,
      winHeight: 0,
      orderSize: 5,
      // tab切换  
      currentTab: 0,
      isStatus: '',
      //10待付款，20待发货，30待收货 40、50已完成
      page: 0,
      refundpage: 0,
      orderList0: [],
      orderList1: [],
      orderList2: [],
      orderList3: [],
      orderList4: [],
      orderList5: [],
      // loadType: "load",
      queryParams: {
        pageNumber: 1,
        pageSize: 5,
        goodsCategoryId: null,
        // type: null,
        // storeType: null,
        brandId: null,
        marketingId: null,
        goodsLabelId: null,
        // startPrice: null,
        // endPrice: null,
        isOutOfStock: null,
        // orderType: "TOP_DESC",
        // orderType: "PRICE_DESC",
        keyword: null,
        storeId: null,
        hasExpired: null,
      },

      objsList: [],
      brandOptions: [],
      goodsCategoryOptions: [],

      tapIndex: 0,
      // objsList: [],
      loadType: "load",

      // 物流弹窗（仅 index 内，调用 view + transit_step）
      logisticsDialogVisible: false,
      logisticsLoading: false,
      logisticsSteps: [],
      logisticsCurrentShipping: null,
      logisticsEmptyText: "",

      //////////////////////////////////////////////////////////////////////////////////////////////////

    };
  },
  computed: {
    // ...mapGetters({
    // orderList: "order/orderList",
    // }),
  },
  watch: {
    async tabActive(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.requestData(newValue ? { status: newValue } : {});
      }
    },
  },
  mounted(){
    this.tapOrderStatus("",null);
  },
  activated() {
    this.tapOrderStatus("",null);
  },
  methods: {
    tabChange(index, status) {
      if (this.tabActive !== index) {
        this.pageNum = 1;
        // this.loading = true
        this.tabActive = index;
        this.tapIndex = index;
        this.tapOrderStatus(this.tapIndex, status);
      }
    },
    ...mapActions({
      requestOrderList: "order/requestOrderList",
    }),
    async requestData(params = {}) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.requestOrderList({
        ...params,
        ...{
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          status: this.tabActive,
        },
      })
        .then((res) => {
          this.total = res.pageInfo?.totalElements || 0;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
      console.log(this.loading);
    },
    currentChange(page) {
      this.queryParams.pageNumber = page;
      this.order_list();
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
           * 查询列表 list
           */
    order_list() {
      list(this.queryParams).then(response => {
        //下拉加载
        // if (this.loadType === "reach") {
        // 	const newObjsList = response.data.data.data.content;
        // 	newObjsList.forEach(item => this.objsList.push(item));
        // 	this.searchLoading = false;
        // 	//加载
        // } else if (this.loadType === "load") {
        this.objsList = response.data.data.data.content;
        this.brandOptions = response.data.data.data.brands;
        this.goodsCategoryOptions = response.data.data.data.goodsCategories;
        this.queryParams.pageNumber = response.data.data.data.pageable.pageNumber;
        this.total = response.data.data.data.total;
        this.totalPages = response.data.data.data.totalPages;

        // this.orderSize = oSize;
        this.loading = false;
        //下拉刷新
        // } else if (this.loadType === "pullDown") {
        // 	uni.stopPullDownRefresh();
        // }

      });
    },



    tapOrderStatus(i, status) {
      console.error(i);
      let index = i;
      this.queryParams.hasExpired = null;
      if (index === "") {
        this.tapIndex = 0;
        delete this.queryParams['status'];
        this.queryParams.hasExpired = null;
      } else if (index === 0) {
        this.tapIndex = 1;
        this.queryParams.status = status;
        this.queryParams.hasExpired = false;
      }
      // if (index == 1) {
      // 	this.tapIndex = 1;
      // 	this.queryParams.status = status;
      // }
      if (index == 1) {
        this.tapIndex = 2;
        this.queryParams.status = 'PENDING_SHIPMENT';
      }
      if (index == 3) {
        this.tapIndex = 3;
        this.queryParams.status = 'SHIPPED';
      }

      this.loadType = "load";
      this.queryParams.pageNumber = 1;
      this.order_list();
    },

    order_reload_data: function (i) {
      this.objsList = [];
      this.loadType = "load";
      this.queryParams.pageNumber = 1;
      this.order_list();
    },
    //订单评价
    order_review: function (order, orderItem) {
      var orderStr = order ? JSON.stringify(order) : null;
      var orderItemStr = orderItem ? JSON.stringify(orderItem) : null;
      uni.navigateTo({
        url: '../../goods/review/index?order=' + orderStr + "&orderItem=" + orderItemStr,
        success: function (res) { // success
        },
        fail: function () { // fail
        },
        complete: function () { // complete
        }
      });
    },

    //订单详情
    order_detail: function (e) {
    },

    //取消订单
    order_remove: function (id) {
      var that = this;
      uni.showModal({
        title: this.messages['common_hint'],
        content: this.messages['shop_order_cancelConfirm'],
        success: function (res) {
          if (res.confirm) {
            cancel({
              "orderId": id
            }).then(response => {
              this.loading=false;
              that.order_reload_data();
            }).catch(error => {
              this.loading=false;
              console.error("error", error);
              uni.showToast({
                title: this.messages['common_message_unknownError'],
                duration: 2000
              });
            })
          }

        }
      });
    },
    //确认收货
    order_receive: function (id) {
      let that = this;
      uni.showModal({
        title: this.messages['common_hint'],
        content: this.messages['shop_order_receiveConfirm'],
        success: function (res) {
          if (res.confirm) {
            receive({
              "orderId": id
            }).then(response => {
              this.loading=false;
              that.order_reload_data();
            }).catch(error => {
              this.loading=false;
              console.error("error", error);
              uni.showToast({
                title: this.messages['common_message_unknownError'],
                duration: 2000
              });
            })
          }

        }
      });
    },

    // 物流查询：先 view 拿 orderShipping，再调 transit_step（与 uni 一致）
    async openLogistics(order) {
      this.logisticsDialogVisible = true;
      this.logisticsLoading = true;
      this.logisticsSteps = [];
      this.logisticsCurrentShipping = null;
      this.logisticsEmptyText = "";

      try {
        const res = await view({ orderId: order.id });
        const data = (res.data && res.data.data) || res.data || res;
        let shipping =
          data.orderShipping ||
          (data.order && data.order.orderShipping) ||
          (data.orderShippings && data.orderShippings[0]) ||
          (data.order && data.order.orderShippings && data.order.orderShippings[0]);

        if (!shipping || !shipping.id) {
          this.logisticsEmptyText = this.$t("message.home.order.noOrderShipping") || "暂无物流单号";
          return;
        }

        this.logisticsCurrentShipping = shipping;

        const stepRes = await transitStep({ orderShippingId: shipping.id });
        const raw =
          (stepRes.data && stepRes.data.data) != null
            ? stepRes.data.data
            : stepRes.data != null
              ? stepRes.data
              : stepRes;
        let steps = raw && raw.transitSteps;
        if (!Array.isArray(steps)) steps = [];
        this.logisticsSteps = steps;
        if (!steps.length) {
          this.logisticsEmptyText = this.$t("message.home.order.noTransitSteps") || "暂无轨迹信息";
        }
      } catch (e) {
        console.error("load logistics error", e);
        this.logisticsSteps = [];
        this.logisticsEmptyText = this.$t("message.home.order.logisticsLoadFail") || "物流查询失败，请稍后重试";
      } finally {
        this.logisticsLoading = false;
      }
    },
    formatLogisticsTime(step) {
      return step.time || step.ftime || step.date || "";
    },
    formatLogisticsText(step) {
      return step.context || step.status || step.description || "";
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////
  },
};
</script>

<style lang="scss" scoped>
html[dir='rtl'] {
  .my-order {
    margin-left: 0;
    margin-right: 50px;
  }
}

.my-order {
  // width: 702px;
  margin-top: 32px;
  margin-left: 50px;
  flex: 1;

  .tabs {
    margin-top: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    // border: 1px solid #eeeeee;
    border-radius: 4px;
    width: 100%;
    // padding: 0 25px;

    .tab-item {
      height: 100%;
      display: flex;
      align-items: center;
      // border-bottom: 2px solid transparent;
      cursor: pointer;
      user-select: none;
      padding: 0 20px;
      background-color: #eeeeee;
      border-radius: 5px;
      color: #999999;

      &.active {
        // border-bottom: 2px solid var(--color-main);
        background-color: var(--color-main);
        color: white;
      }
    }
  }

  .order-list {
    v::deep .option-list {
      .option-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        padding: 10px 0;

        +.option-item {
          border-top: 1px solid #eee;
        }

        &.block {
          display: block;

          .value {
            flex: inherit;
            max-width: 100%;
            text-align: left;
          }
        }

        .label {
          flex: 1;
          font-size: 14px;
          color: #333333;
        }

        .value {
          flex: 2;
          max-width: 300px;
          font-size: 14px;
          color: #666666;
          text-align: right;

          .text {
            font-weight: 600;
            font-size: 14px;
            color: #000000;
          }

          .desc {
            font-weight: 500;
            font-size: 12px;
            color: #999999;
            margin-top: 4px;
          }

          .price {
            font-weight: 500;
            font-size: 16px;
            color: var(--color-price);
          }

          .detail-link {
            font-size: 14px;
            line-height: 16px;
            color: var(--color-main);
            cursor: pointer;
            user-select: none;
          }

          .product-item {
            display: flex;
            width: 100%;
            align-items: center;
            margin-top: 15px;

            img {
              width: 62px;
              height: 62px;
            }

            .title {
              flex: 1;
              margin-left: 18px;
              font-weight: 400;
              font-size: 14px;
            }
          }
        }
      }
    }

    v::deep .actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      >*+* {
        margin-left: 16px;
      }

      .status {
        text-align: right;

        &.unReturn {
          color: #999;
        }

        &.running {
          color: var(--color-main);
        }

        &.success {
          color: #32aa15;
        }

        &.fail {
          color: #e10015;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.logistics-dialog {
  .logistics-content {
    min-height: 320px;
    padding: 8px 0;
  }
  .logistics-header {
    padding: 12px 16px;
    margin-bottom: 16px;
    background: linear-gradient(135deg, #f8f9fc 0%, #eef1f8 100%);
    border-radius: 8px;
    .logistics-express,
    .logistics-tracking {
      margin-bottom: 6px;
      font-size: 13px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .label {
      color: #666;
      margin-right: 6px;
    }
    .value {
      color: #1a1a1a;
      font-weight: 500;
    }
  }
  .logistics-timeline-wrap {
    padding: 0 8px;
    .el-timeline-item__timestamp {
      font-size: 12px;
      color: #999;
    }
    .step-desc {
      font-size: 13px;
      color: #333;
      line-height: 1.5;
    }
  }
  .logistics-empty {
    padding: 48px 24px;
    text-align: center;
    color: #999;
    font-size: 14px;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
